/** For an action the user just triggered. Content that will arrive gets a
 *  skeleton instead — a spinner where a list will appear says less. */
export function Spinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex justify-center p-8 text-fg-muted" role="status">
      <span
        aria-hidden="true"
        className="size-5 animate-spin rounded-full border-2 border-current border-t-transparent"
      />
      <span className="sr-only">{label}</span>
    </div>
  )
}
